// platform/* page translations
const platform = {
  layout: {
    menu: {
      companies: 'Quản lý công ty',
      users: 'Tất cả người dùng',
      status: 'Trạng thái hệ thống',
      licenses: 'Quản lý giấy phép',
    },
  },
  companies: {
    stats: {
      total: 'Tổng công ty',
      active: 'Công ty hoạt động',
      users: 'Tổng người dùng',
      equipments: 'Tổng thiết bị',
    },
    listTitle: 'Danh sách công ty',
    addBtn: 'Đăng ký công ty',
    loading: 'Đang tải...',
    empty: 'Không có công ty nào.',
    col: {
      code: 'Mã',
      name: 'Tên công ty',
      schema: 'Schema',
      ceo: 'Đại diện',
      users: 'Người dùng',
      plan: 'Gói',
      status: 'Trạng thái',
      createdAt: 'Ngày đăng ký',
      actions: 'Quản lý',
    },
    usersSuffix: '{n}',
    actions: {
      delete: 'Xóa',
    },
    confirmDelete: 'Bạn có chắc muốn xóa công ty "{name}"?\n\nKhi xóa, các dữ liệu sau sẽ bị xóa:\n- Thông tin công ty\n- Tất cả tài khoản người dùng\n- Schema và dữ liệu tenant\n\nHành động này không thể hoàn tác.',
    alertDeleted: 'Đã xóa công ty "{name}".',
    alertDeleteFail: 'Xóa thất bại: {error}',
    alertDeleteError: 'Đã xảy ra lỗi khi xóa công ty.',
    alertUnknownError: 'Lỗi không xác định',
  },
  companyRegister: {
    title: 'Đăng ký công ty',
    sectionBasic: 'Thông tin cơ bản',
    sectionContact: 'Thông tin liên hệ',
    sectionSubscription: 'Thông tin gói đăng ký',
    sectionAdmin: 'Tài khoản quản trị',
    adminDescription: 'Thông tin tài khoản quản trị viên sẽ được tạo cùng với công ty.',
    fields: {
      name: 'Tên công ty',
      code: 'Mã công ty',
      schema: 'Tên schema',
      ceo: 'Tên đại diện',
      businessNumber: 'Mã số đăng ký kinh doanh',
      contactEmail: 'Email liên hệ',
      contactPhone: 'Điện thoại liên hệ',
      address: 'Địa chỉ',
      plan: 'Gói đăng ký',
      status: 'Trạng thái đăng ký',
      maxUsers: 'Số người dùng tối đa',
      maxEquipments: 'Số thiết bị tối đa',
      adminUsername: 'Tên đăng nhập admin (email)',
      adminEmail: 'Email admin',
      adminPassword: 'Mật khẩu',
      adminPasswordConfirm: 'Xác nhận mật khẩu',
    },
    placeholder: {
      name: 'Nhập tên công ty',
      code: 'Chỉ chữ thường và số (VD: company1)',
      schema: 'Tự động tạo khi nhập mã công ty',
      ceo: 'Nhập tên đại diện',
      businessNumber: 'Chỉ nhập số',
      contactEmail: 'company@example.com',
      contactPhone: '02-1234-5678',
      address: 'Nhập địa chỉ công ty',
      adminUsername: 'admin@example.com',
      adminEmail: 'admin@example.com',
      adminPassword: 'Tối thiểu 8 ký tự',
      adminPasswordConfirm: 'Nhập lại mật khẩu',
    },
    schemaHint: 'Tự động tạo dựa trên mã công ty',
    plan: {
      basic: 'Basic',
      standard: 'Standard',
      premium: 'Premium',
      enterprise: 'Enterprise',
    },
    status: {
      trial: 'Trial (Dùng thử)',
      active: 'Active (Hoạt động)',
      suspended: 'Suspended (Tạm ngừng)',
    },
    cancel: 'Hủy',
    submit: 'Đăng ký công ty',
    submitting: 'Đang đăng ký...',
    success: 'Đăng ký công ty thành công.',
    fail: 'Đăng ký công ty thất bại.',
    error: 'Đã xảy ra lỗi khi đăng ký công ty.',
    validation: {
      nameRequired: 'Vui lòng nhập tên công ty',
      codeRequired: 'Vui lòng nhập mã công ty',
      codeLength: 'Mã công ty phải có 2-20 ký tự',
      ceoRequired: 'Vui lòng nhập tên đại diện',
      businessNumberInvalid: 'Định dạng mã số kinh doanh không hợp lệ (VD: 123-45-67890)',
      contactEmailInvalid: 'Định dạng email không hợp lệ',
      contactPhoneInvalid: 'Định dạng điện thoại không hợp lệ (VD: 02-1234-5678)',
      maxUsersMin: 'Tối thiểu 1 người',
      maxEquipmentsMin: 'Tối thiểu 1 thiết bị',
      adminUsernameRequired: 'Vui lòng nhập tên đăng nhập admin (email)',
      adminEmailInvalid: 'Định dạng email không hợp lệ',
      adminEmailRequired: 'Vui lòng nhập email admin',
      adminPasswordRequired: 'Vui lòng nhập mật khẩu',
      adminPasswordLength: 'Mật khẩu tối thiểu 8 ký tự',
      adminPasswordMismatch: 'Mật khẩu không khớp',
    },
  },
  globalUsers: {
    stats: {
      total: 'Tổng người dùng',
      admin: 'Quản trị viên',
      active: 'Người dùng hoạt động',
    },
    listTitle: 'Danh sách người dùng',
    filterAllCompanies: 'Tất cả công ty',
    loading: 'Đang tải...',
    empty: 'Không có người dùng.',
    col: {
      name: 'Tên người dùng',
      email: 'Email',
      company: 'Công ty',
      role: 'Vai trò',
      status: 'Trạng thái',
      lastLogin: 'Đăng nhập gần nhất',
    },
    role: {
      superAdmin: 'Super Admin',
      admin: 'Admin',
      user: 'Người dùng',
    },
    statusActive: 'Hoạt động',
    statusInactive: 'Vô hiệu',
  },
  systemStatus: {
    stats: {
      totalCompanies: 'Tổng công ty',
      activeCompanies: 'Công ty hoạt động',
      totalUsers: 'Tổng người dùng',
      activeUsers: 'Người dùng hoạt động',
    },
    serviceStatus: 'Trạng thái dịch vụ',
    refresh: 'Làm mới',
    col: {
      service: 'Dịch vụ',
      status: 'Trạng thái',
      url: 'URL',
    },
    statusRunning: 'Đang chạy',
    statusError: 'Lỗi',
    noStatus: 'Không nhận được trạng thái từ máy chủ',
    etlTitle: 'Trạng thái ETL',
    etl: {
      lastRun: 'Lần chạy cuối',
      status: 'Trạng thái',
      records: 'Bản ghi đã xử lý',
      sync: 'Chu kỳ đồng bộ',
      success: 'Thành công',
      noData: 'Không có dữ liệu',
      error: 'Lỗi',
      recordsSuffix: '{n}',
    },
    dbTitle: 'Trạng thái cơ sở dữ liệu',
    db: {
      tables: 'Tổng số bảng',
      records: 'Tổng bản ghi',
      size: 'Dung lượng DB',
      tablesSuffix: '{n}',
    },
  },
  licenseManagement: {
    stats: {
      total: 'Tổng giấy phép',
      active: 'Giấy phép hoạt động',
      expiring: 'Sắp hết hạn (trong 30 ngày)',
    },
    listTitle: 'Danh sách giấy phép',
    loading: 'Đang tải...',
    empty: 'Không có giấy phép.',
    col: {
      company: 'Công ty',
      type: 'Loại giấy phép',
      users: 'Người dùng',
      equipments: 'Thiết bị',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày hết hạn',
      status: 'Trạng thái',
    },
    type: {
      enterprise: 'Enterprise',
      standard: 'Standard',
      basic: 'Basic',
      trial: 'Bản dùng thử',
    },
    daysRemaining: 'còn {n} ngày',
    statusActive: 'Hoạt động',
    statusExpired: 'Hết hạn',
  },
};

export default platform;
